'use client'

import { useState } from 'react'

import { deleteObject, getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage'
import { Url } from 'next/dist/shared/lib/router/router'
import { toast } from 'react-toastify'

import { useUploadsIMGMutation } from '@/redux/api/post-cre/post.w3'

const useUploadImage = () => {
  const storage = getStorage()
  const [selectedImage, setSelectedImage] = useState<any | Url>(null)
  const [previousImage, setPreviousImage] = useState<any | Url>(null) // Add previousImage state
  const [loading, setLoading] = useState(false) // Add loading state
  const [uploadsIMG] = useUploadsIMGMutation()

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const fileupload = event.target.files[0]
      const fileName = fileupload.name

      // Save the current image as the previous image before uploading a new one
      setPreviousImage(selectedImage)

      if (selectedImage) {
        const imageRef = ref(storage, selectedImage)
        deleteObject(imageRef)
      }

      const image = ref(storage, `images/${fileName}-${crypto.randomUUID()}`)
      setLoading(true) // Start loading
      uploadBytes(image, fileupload)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((img) => {
              setSelectedImage(img)
              setLoading(false) // End loading
            })
            .catch(() => {
              setLoading(false) // End loading on error
              toast.error('Error uploading image')
            })
        })
        .catch(() => {
          setLoading(false) // End loading on error
          toast.error('Error uploading image')
        })
    } else {
      setSelectedImage(null)
    }
  }

  const handleUploadImage = async (images: File[]) => {
    try {
      setLoading(true)
      const uploadedUrls = await Promise.all(
        images.map(async (image) => {
          const formData = new FormData()
          formData.append('image', image)
          const { data } = await uploadsIMG(formData)
          return data?.url || null
        }),
      )
      const filteredUrls = uploadedUrls.filter((url) => url !== null) as string[]
      setLoading(false)
      return filteredUrls
    } catch (error) {
      setLoading(false)
      console.error('Error uploading images:', error)
      return []
    }
  }

  const handleRemoveImage = () => {
    // Restore the previous image when removing the current one
    setSelectedImage(previousImage)
    setPreviousImage(null)
  }

  return {
    selectedImage,
    previousImage,
    loading,
    handleImageUpload,
    handleUploadImage,
    handleRemoveImage,
    setSelectedImage,
  }
}

export default useUploadImage
